import { Link } from "react-router-dom";
import { CalendarCheck, CreditCard, LockKeyhole, ShieldCheck } from "lucide-react";
import { LAUNCH_DATE_ISO, LAUNCH_DATE_LABEL } from "@/components/landing/Trust";

const items = [
  {
    icon: LockKeyhole,
    title: "Try before you buy",
    body: "Three complete blueprints are readable for free in the marketplace — no card, no signup.",
  },
  {
    icon: ShieldCheck,
    title: "14-day full refund",
    body: "Email info@skaiboss.com within 14 days and we refund the whole $39. No forms.",
  },
  {
    icon: CreditCard,
    title: "Secure card payment",
    body: "Payments are processed by Stripe. We never see or store your card details.",
  },
  {
    icon: CalendarCheck,
    title: "Live since launch",
    body: `Public since ${LAUNCH_DATE_LABEL}, with a published roadmap of what comes next.`,
  },
];

/** Compact trust block shown directly under the $39 offer. */
const PricingTrust = () => (
  <div
    className="mt-14 max-w-4xl mx-auto"
    aria-labelledby="pricing-trust-heading"
    data-testid="pricing-trust"
  >
    <h3
      id="pricing-trust-heading"
      className="text-center font-mono text-xs text-primary tracking-wider"
    >
      // WHY THIS IS SAFE TO BUY
    </h3>

    <ul className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map(({ icon: Icon, title, body }) => (
        <li key={title} className="rounded-xl border border-border bg-card p-5">
          <Icon className="size-5 text-primary" aria-hidden="true" />
          <div className="mt-3 text-sm font-medium">{title}</div>
          <p className="mt-1 text-xs text-muted-foreground leading-relaxed">{body}</p>
        </li>
      ))}
    </ul>

    <p className="mt-6 text-center text-xs text-muted-foreground">
      <time dateTime={LAUNCH_DATE_ISO}>Launched {LAUNCH_DATE_LABEL}</time> ·{" "}
      <Link to="/marketplace" className="text-primary hover:underline">
        Browse free samples
      </Link>{" "}
      ·{" "}
      <Link to="/roadmap" className="text-primary hover:underline">
        Public roadmap
      </Link>{" "}
      ·{" "}
      <Link to="/support" className="text-primary hover:underline">
        Talk to us first
      </Link>
    </p>
  </div>
);

export default PricingTrust;
